import { createAction } from '@reduxjs/toolkit';

export const addToken = createAction('occ/add_token');
